import {api} from './api';

export interface ContactMessageItem {
    id: number;
    subject: string;
    content: string;
    salutation: string;
    contactEmail: string;
    phone: string | null;
    deleted: string;
    status: string;
    ipAddress: string | null;
    createdTime: string;
    updatedTime: string;
}

export interface PageResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

export const contactMessageService = {
    getList: async (page: number = 0, size: number = 20): Promise<PageResponse<ContactMessageItem>> => {
        const response = await api.get(`/api/v1/admin/contact-messages?page=${page}&size=${size}`);
        return response.data.data;
    },

    getDetail: async (id: number): Promise<ContactMessageItem> => {
        const response = await api.get(`/api/v1/admin/contact-messages/${id}`);
        return response.data.data;
    },

    updateStatus: async (id: number, status: string): Promise<ContactMessageItem> => {
        const response = await api.put(`/api/v1/admin/contact-messages/${id}/status?status=${status}`);
        return response.data.data;
    },

    delete: async (id: number): Promise<void> => {
        await api.delete(`/api/v1/admin/contact-messages/${id}`);
    },

    submit: async (data: {
        subject: string;
        content: string;
        salutation: string;
        contactEmail: string;
        phone?: string;
    }): Promise<ContactMessageItem> => {
        const response = await api.post('/api/v1/public/contact', data);
        return response.data.data;
    },
};
